import { useEffect, useRef } from 'react';

import type { SlideoutEntry } from '@/lib/crm/contexts/SlideoutStackContext';

// Auto-open the conversation's most recent proposal — on chat load and the
// moment a new proposal lands — mirroring the builder panel's always-shows-
// the-latest behavior. The ref makes a manual close STICK: once an id has
// been auto-opened (or deliberately skipped), it never re-opens on its own;
// only a NEW proposal id triggers the pane again. A deep link (topEntry
// already present on arrival) wins over the auto-open, but still marks the
// id handled so closing the deep-linked surface doesn't summon the pane.
export function useAutoOpenLatestProposal(
  canHostInlineProposal: boolean,
  latestProposalId: number | undefined,
  topEntry: SlideoutEntry | undefined,
  openProposal: (id: number, proposalIds?: number[]) => void
): void {
  const lastAutoOpenedProposalRef = useRef<number | undefined>(undefined);
  useEffect(() => {
    if (!canHostInlineProposal || latestProposalId === undefined) {
      return;
    }
    if (lastAutoOpenedProposalRef.current === latestProposalId) {
      return;
    }
    lastAutoOpenedProposalRef.current = latestProposalId;
    if (topEntry !== undefined) {
      return;
    }
    openProposal(latestProposalId);
  }, [canHostInlineProposal, latestProposalId, topEntry, openProposal]);
}
